<svg
  #svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="-40 -40 280 280"
  role="status"
  [attr.aria-label]="ariaLabel"
  xmlns="http://www.w3.org/2000/svg"
>
  <defs>
    <filter [attr.id]="'octa-goo-' + uid" x="-20%" y="-20%" width="140%" height="140%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
      <feColorMatrix
        in="blur"
        type="matrix"
        values="1 0 0 0 0
                0 1 0 0 0
                0 0 1 0 0
                0 0 0 22 -11"
        result="goo"
      />
      <feBlend in="SourceGraphic" in2="goo" />
    </filter>
  </defs>
  <g #group [attr.filter]="'url(#octa-goo-' + uid + ')'"></g>
</svg>
